import { CONTRACT_SUBJECT_TO } from '@/config/constants';

/**
 * Wording for the contract's property-condition clause, shared by the
 * on-screen preview and the PDF. "Subject To" offers name their conditions
 * and list the buyer's requested repairs (which were previously dropped).
 */
export function getPropertyConditionClause(offer?: {
  propertyCondition?: string;
  subjectTo?: string;
  additionalSubjectTo?: string;
  requestedRepairs?: string;
}): { statement: string; repairs: string[] } {
  const condition = offer?.propertyCondition;
  const conditions = [offer?.subjectTo, offer?.additionalSubjectTo].filter(
    (c): c is string =>
      !!c && c !== CONTRACT_SUBJECT_TO.NO_ADDITIONAL_SUBJECT_TO_CLAUSES
  );
  const repairs = (offer?.requestedRepairs || '')
    .split(/\r?\n|;/)
    .map((r) => r.trim())
    .filter(Boolean);
  const statement =
    condition === 'Subject To'
      ? `The Property is being purchased subject to ${
          conditions.length ? conditions.join(' and ') : 'the conditions below'
        }.`
      : `The Property is being purchased in ${condition || 'N/A'} condition.`;
  return { statement, repairs };
}

export const REPAIRS_LEAD_IN =
  'Seller shall complete the following repairs, in a workmanlike manner, prior to Settlement:';
